
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      defaultStyle: {
        fontSize: 14,
        height: 30,
        color: "#fff",
        background: "#DC2626",
      },
      raf: null,
    };
  },

  computed: {
    ...mapGetters({
      settings: "SETTINGS",
    }),

    banner() {
      return this.settings?.components?.maintenanceBanner || {};
    },

    visible() {
      return !!(this.banner.enabled && this.banner.text);
    },
  },

  watch: {
    // The banner sits above a sticky header in normal flow, so it scrolls away.
    // Publish its currently-visible height so viewport-fixed overlays (search,
    // mobile nav) can offset their `top` and not overlap the header.
    visible: {
      immediate: true,
      handler(isVisible) {
        this.$nextTick(() => {
          if (isVisible) this.startOffsetTracking();
          else this.stopOffsetTracking();
        });
      },
    },
  },

  beforeDestroy() {
    this.stopOffsetTracking();
  },

  methods: {
    setOffset(px) {
      if (typeof document === "undefined") return;
      document.documentElement.style.setProperty(
        "--maintenance-banner-offset",
        px + "px"
      );
    },

    updateOffset() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        const el = this.$refs.banner;
        const px = el
          ? Math.max(0, Math.round(el.getBoundingClientRect().bottom))
          : 0;
        this.setOffset(px);
      });
    },

    startOffsetTracking() {
      if (typeof window === "undefined") return;
      this.updateOffset();
      window.addEventListener("scroll", this.updateOffset, { passive: true });
      window.addEventListener("resize", this.updateOffset);
    },

    stopOffsetTracking() {
      if (typeof window === "undefined") return;
      window.removeEventListener("scroll", this.updateOffset);
      window.removeEventListener("resize", this.updateOffset);
      if (this.raf) {
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }
      this.setOffset(0);
    },
  },
};
